import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useUser } from "../UserContext";
import { useLocation } from "react-router-dom";

const CancelSubscriptionReviews = ({ isOpen, onClose, onSubmit, subscriptionToCancel, facilityId, setLoading, setCancelProcessModal }) => {
    const [questions, setQuestions] = useState([]);
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [selectQuestionText, setSelectedQuestionText] = useState([])
    const [otherReason, setOtherReason] = useState("");
    const location = useLocation();

    const token = localStorage.getItem("token");
    const user = useUser();
    const ACCESS_TOKEN = process.env.REACT_APP_TICKET_ACCESS_TOKEN;
    const APP_URL = process.env.REACT_APP_FRONTEND_URL;
    const TICKET_URL = process.env.REACT_APP_API_BASE_URL;

    const fetchQuestions = async () => {
        try {
            setLoading(true)
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/get-questionare/`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error();
            const data = await response.json();
            setQuestions(data);
            setLoading(false)
        } catch {
            toast.error("Failed to load questions");
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchQuestions();

    }, []);

    const toggleQuestion = (review) => {
        setSelectedQuestions((prev) =>
            prev.includes(review?.id)
                ? prev.filter((q) => q !== review?.id)
                : [...prev, review?.id]
        );
        setSelectedQuestionText((prev) =>
            prev.includes(review?.id)
                ? prev.filter((q) => q !== review?.id)
                : [...prev, review?.title]
        );

    };

    const userDetails = user?.user?.user;
    const facilityDetail = user?.user?.facility;

    const TICKET_HEADERS = {
        "Content-Type": "application/json",
        "Accept": "application/json",
    };

    const [lastVisited, setLastVisited] = useState(() => localStorage.getItem("lastVisited") || "");

    useEffect(() => {
        localStorage.setItem("lastVisited", location.pathname);
        setLastVisited(location.pathname);
    }, [location]);

    const selectedReasonsHtml = selectQuestionText?.map((reason, index) => `${index + 1}. ${reason}`).join("<br/>");
    const handleSubmitQuery = async () => {
        console.log("handleSubmitQuery START");
        setLoading(true)
        try {
            let newTicketId = `TKT-${Math.floor(Math.random() * 10000)}`;

            // Send to new Ticket Platform
            try {
                const TICKET_API = process.env.REACT_APP_WIDGET_API_URL || "http://localhost:4000";
                console.log("Preparing to hit TICKET_API:", `${TICKET_API}/api/widget/tickets`);

                const plainReasons = selectedReasonsHtml ? selectedReasonsHtml.replace(/<br\/>/g, '\n') : "No specific reasons selected.";
                const htmlReasons = selectedReasonsHtml || "No specific reasons selected.";

                const descText = `Hello,\n\nI am writing to formally request the cancellation of my subscription for the facility: ${facilityDetail?.name || "Unknown Facility"}.\n\nHere are my reasons for cancelling:\n${plainReasons}${otherReason ? `\n\nAdditional Comments:\n${otherReason}` : ""}\n\nPlease process this cancellation at your earliest convenience. Thank you.`;

                const descHtml = `<p>Hello,</p><p>I am writing to formally request the cancellation of my subscription for the facility: <strong>${facilityDetail?.name || "Unknown Facility"}</strong>.</p><p><strong>Here are my reasons for cancelling:</strong><br/>${htmlReasons}</p>${otherReason ? `<p><strong>Additional Comments:</strong><br/>${otherReason}</p>` : ""}<p>Please process this cancellation at your earliest convenience. Thank you.</p>`;

                const requestBody = {
                    name: userDetails?.first_name || userDetails?.username || "Unknown",
                    email: userDetails?.email, // Required by widget API
                    subject: "Subscription Cancellation",
                    description: descText,
                    descriptionHtml: descHtml,
                    facility: facilityDetail?.name || "Unknown Facility",
                    priority: "NORMAL",
                    type: "PROBLEM",
                    pageUrl: APP_URL + (lastVisited || '')
                };

                console.log("Request Payload:", requestBody);

                // Hit the public widget endpoint (No token needed!)
                const newTicketRes = await fetch(`${TICKET_API}/api/widget/tickets`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(requestBody),
                });

                console.log("TICKET_API Response Status:", newTicketRes.status);

                const ticketData = await newTicketRes.json();
                console.log("TICKET_API Response Data:", ticketData);

                if (ticketData?.referenceNumber) {
                    newTicketId = ticketData.referenceNumber;
                } else if (ticketData?.id) {
                    newTicketId = ticketData.id;
                }

            } catch (widgetErr) {
                console.error("Failed to send ticket to new widget platform:", widgetErr);
            }

            const DBTICKETPAYLOD = {
                ticket_id: newTicketId,
                user: userDetails?.id,
                subject: 'Subscription Cancellation',
                message: selectedReasonsHtml || "",
                status: "open",
                type: "Support",
                email: userDetails?.email
            };

            console.log("Saving to DB:", DBTICKETPAYLOD);

            await fetch(`${TICKET_URL}/tickets/create/`, {
                method: "POST",
                headers: TICKET_HEADERS,
                body: JSON.stringify({
                    ...DBTICKETPAYLOD
                }),
            });
            console.log("Saved to DB successfully.");

            setLoading(false)
            setCancelProcessModal(true)
            console.log("handleSubmitQuery END Success");
        } catch (error) {
            console.error("handleSubmitQuery Outer Catch:", error);
            setLoading(false)
            setCancelProcessModal(false)
        }
    }
    const handleSubmit = async () => {
        setLoading(true)
        const payload = {
            reason: selectedQuestions,
            additional_comments: otherReason,
            subscription: subscriptionToCancel,
            facility: facilityId,
        };
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/subscription-cancel-reason/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                setLoading(false);
                throw new Error("Failed to submit cancellation reason");
            } else {
                await handleSubmitQuery();
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to cancel subscription. Please try again.");
            setLoading(false);
        }

        onClose();
        setLoading(false);
    };



    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-white w-full max-w-4xl rounded-2xl shadow-xl">

                {/* Header */}
                <div className="p-6 border-b flex justify-between items-center">
                    <h2 className="text-4xl font-semibold text-gray-800 m-0">
                        Why are you cancelling?
                    </h2>
                </div>

                {/* Body */}
                <div className="p-6 max-h-[60vh] overflow-y-auto space-y-4">

                    {/* Info Banner */}
                    <div className="bg-red-50 border-l-4 border-red-600 p-5 rounded-lg mb-6 shadow-md">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <i className="fa-solid fa-triangle-exclamation text-red-600 mt-1 text-2xl"></i>
                            </div>
                            <div className="ml-4">
                                <p className="text-xl font-semibold text-red-900 m-0">
                                    Submitting this form will send a cancellation request to our support team. Your subscription will be canceled once the request is reviewed and processed.
                                </p>
                            </div>
                        </div>
                    </div>

                    {questions?.map((q) => (
                        <label
                            key={q?.id}
                            className="flex items-start gap-3 p-4 border rounded-xl cursor-pointer hover:bg-gray-50 transition"
                        >
                            <input
                                type="checkbox"
                                checked={selectedQuestions.includes(q?.id)}
                                onChange={() => toggleQuestion(q)}
                                className="mt-1 w-6 h-6 accent-emerald-600"
                            />
                            <span className="text-gray-700 font-medium">
                                {q?.title}
                            </span>
                        </label>
                    ))}

                    {/* Other reason */}
                    <div className="pt-4">
                        <label className="block font-medium text-gray-700 mb-2">
                            Other reason (optional)
                        </label>
                        <textarea
                            rows={3}
                            value={otherReason}
                            onChange={(e) => setOtherReason(e.target.value)}
                            placeholder="Tell us anything else..."
                            className="w-full border rounded-xl p-3 focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-3 p-6 border-t">
                    <button
                        onClick={onClose}
                        className="px-4 py-3 rounded-lg border hover:bg-gray-100"
                    >
                        Keep Subscription
                    </button>
                    <button
                        disabled={otherReason ? false : selectedQuestions?.length === 0}
                        onClick={handleSubmit}
                        className="px-4 py-3 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
                    >
                        Cancel Subscription
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelSubscriptionReviews;
